import { config } from '@/_helpers'
import { userService } from '@/_services'
import axios from 'axios'

import * as NodeCache from 'node-cache'
let cache = new NodeCache()

axios.Axios.prototype['cacheGet'] = function(url, config = {}) {
  config.headers = { ...config.headers, 'If-None-Match': '' }
  return this.get(url, config)
}

let cms_options = {
  baseURL: config.cmsUrl,
  headers: { 'Content-Type': 'application/json' }
}

export const $_cms_server = axios.create(cms_options)

let options = {
  baseURL: config.apiUrl,
  headers: { 'Content-Type': 'application/json' }
}

export const $_app_server_noAuth = axios.create(options)

export const $_app_server = axios.create(options)

let token = localStorage.getItem('access_token')
if (token && token.length > 0) {
  $_app_server.defaults.headers.common.Authorization = 'Bearer ' + token
}

$_app_server.interceptors.request.use(requestInterceptor)
$_app_server.interceptors.response.use(responseInterceptor, responseErrorInterceptor)

function requestInterceptor (config) {
  if ('If-None-Match' in config.headers) {
    const cachedResult = cacheByConfig(config)
    config.headers['If-None-Match'] = cachedResult ? cachedResult.etag : ''
  }
  return config
}

function responseInterceptor (response) {
  if (response.headers.etag) {
    const uuid = uuidByConfig(response.config)
    cache.set(uuid, { etag: response.headers.etag, value: response.data })
  }
  return response
}

/*function responseErrorInterceptor (error) {
  if (error.response.status === 304) {
    const cachedResult = cacheByConfig(error.response.config)
    if (cachedResult) { 
      const newResponse = error.response
      newResponse.status = 203
      newResponse.data = cachedResult.value
      return Promise.resolve(newResponse)
    }
  }
  let token = localStorage.getItem('access_token')
  if (error.response.status === 500 && !token) {
    userService.logout()
  }
  if (error.response.status === 401) {
    return userService.refreshToken().then(() => {
      $_app_server.defaults.headers.common.Authorization = 'Bearer ' + token
      error.config.headers.Authorization = 'Bearer ' + token
      error.config.baseURL = undefined;
      return $_app_server.request(error.config);
    })
    .catch(() => userService.logout());
  }
  return Promise.reject(error)
}*/

function responseErrorInterceptor (error) {
  if (error.response !== undefined) {
    if (error.response.status === 304) {
      const cachedResult = cacheByConfig(error.response.config)
      if (cachedResult) { 
        const newResponse = error.response
        newResponse.status = 203
        newResponse.data = cachedResult.value
        return Promise.resolve(newResponse)
      }
    }

    let token = localStorage.getItem('access_token')
    if (error.response.status === 500 && !token) {
      userService.logout()
    }

    if (error.response.status === 401 && error.config.url.indexOf("oauth/token") != 0) {
      return userService.refreshToken().then(() => {
        $_app_server.defaults.headers.common.Authorization = 'Bearer ' + token
        error.config.headers.Authorization = 'Bearer ' + token
        error.config.baseURL = undefined;
        return $_app_server.request(error.config);
      })
      .catch(() => {
        userService.logout()
      } );
    }

    if (error.response.status === 403 || error.response.status === 400) {
      if (error.config.url.indexOf("oauth/token") == 0) {
        userService.logout()
      } else {  
        error.response.data.error_description = "Error login"
      }
    }
  }
  return Promise.reject(error)
}


function uuidByConfig (config) {
  return config.url.startsWith(config.baseURL) ? config.url : config.baseURL + config.url
}

function cacheByConfig (config) {
  const uuid = uuidByConfig(config)
  return cache.get(uuid)
}